import { render, staticRenderFns } from "./popup-bao-gong.vue?vue&type=template&id=4fd77a19&scoped=true"
import script from "./popup-bao-gong.vue?vue&type=script&lang=js"
export * from "./popup-bao-gong.vue?vue&type=script&lang=js"
import style0 from "./popup-bao-gong.vue?vue&type=style&index=0&id=4fd77a19&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd77a19",
  null
  
)

export default component.exports